import React from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import SophisticatedTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SophisticatedTooltip';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
const CommentTooltip = ({ className, children, onDismiss, onDismissAndComment })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(SophisticatedTooltip, {
        isVisible: true,
        hasCloseButton: true,
        onClose: onDismiss,
        size: "medium",
        className: className,
        placement: "top",
        heading: t('actionbar.download.suggestCommenting.header'),
        description: t('actionbar.download.suggestCommenting.description'),
        postfix: /*#__PURE__*/ React.createElement(SophisticatedTooltipLink, {
            onClick: onDismissAndComment,
            biData: BiData({
                evid: 105,
                sectionname: 'download_popup',
                typeid: BiContextProvidedValue,
                itemid: BiContextProvidedValue,
                creatorid: BiContextProvidedValue,
                sectionid: BiContextProvidedValue,
                section_typeid: BiContextProvidedValue,
                sectiontype: BiContextProvidedValue,
                sectionrank: BiContextProvidedValue,
                rank: BiContextProvidedValue,
                sort_type: BiContextProvidedValue,
                reason_shown: BiContextProvidedValue,
                widgetname: BiContextProvidedValue
            })
        }, t('actionbar.download.suggestCommenting.CTA'))
    }, children);
};
CommentTooltip.displayName = 'CommentTooltip';
export default CommentTooltip;

//# sourceMappingURL=CommentTooltip.js.map